function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import SearchIcon from "@mui/icons-material/Search";
import FormGroup from "@mui/material/FormGroup";
import Fab from "@mui/material/Fab";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../../customer/components";
import { isFieldEmpty } from "@limitless/common/utils";
class SearchField extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      searchTerm: this.props.initialValue ? this.props.initialValue : "",
      hasChanged: false,
      isValid: false,
      focus: false
    });
    _defineProperty(this, "handleChange", event => {
      const {
        onChange,
        onSubmit
      } = this.props;
      let searchTerm = event.target.value;
      let valid = searchTerm ? true : false;
      valid = searchTerm.length > 2 ? true : false;
      this.setState({
        searchTerm,
        hasChanged: true,
        isValid: valid
      });
      //on trigger on change if it's been passed in
      if (typeof onChange === "function") {
        onChange(searchTerm);
      }
      searchTerm = searchTerm.trim();
      if (event.which === 13 || event.keyCode === 13) {
        if (onSubmit && valid) {
          this.handleSubmit(searchTerm);
        }
      }
    });
    _defineProperty(this, "handleSubmit", value => {
      this.props.onSubmit(value);
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      if (nextProps.value === "" && this.state.isValid) {
        this.setState({
          isValid: false
        });
      }
      if (nextProps.value && !this.state.isValid) {
        this.setState({
          isValid: true
        });
      }
    }
    this.setState({
      isValid: !isFieldEmpty(nextProps.value) && nextProps.value.length > 2
    });
  }
  render() {
    const {
      classes,
      t,
      label,
      id,
      submitButtonTitle,
      onSubmit,
      value,
      autoFocus,
      loading,
      autoComplete
    } = this.props;
    const {
      searchTerm,
      isValid,
      focus
    } = this.state;
    const inputValue = value !== undefined ? value : searchTerm;
    const portalInputClasses = {
      root: classes.root,
      focused: classes.focused,
      notchedOutline: classes.notchedOutline
    };
    return /*#__PURE__*/React.createElement(FormGroup, {
      className: classes.searchFieldContainer
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary",
      variant: "body1",
      className: classes.title
    }, t(label)), /*#__PURE__*/React.createElement(FormControl, {
      className: `${classes.formControl} ${focus ? classes.formControlFocus : classes.formControlBlur}`
    }, /*#__PURE__*/React.createElement(OutlinedInput, {
      id: id,
      type: "text",
      value: inputValue,
      onChange: this.handleChange,
      onFocus: () => this.setState({
        focus: true
      }),
      onBlur: () => this.setState({
        focus: false
      }),
      onKeyPress: this.handleChange,
      fullWidth: true,
      autoFocus: autoFocus,
      classes: portalInputClasses,
      autoComplete: autoComplete
    }), onSubmit && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Fab, {
      color: "secondary",
      size: "small",
      onClick: () => this.handleSubmit(value),
      disabled: !isValid || loading,
      className: classes.submitButton,
      id: `${submitButtonTitle.toLowerCase()}Button`
    }, /*#__PURE__*/React.createElement(SearchIcon, null)), loading && /*#__PURE__*/React.createElement(CircularProgress, {
      className: classes.progress,
      size: 47,
      color: "secondary"
    }))));
  }
}
const styles = theme => ({
  searchFieldContainer: {
    height: 92
  },
  title: {
    marginBottom: 3
  },
  root: {
    borderWidth: 0,
    fontSize: "0.8125rem",
    "&:hover $notchedOutline": {
      borderWidth: 0
    },
    "&$focused $notchedOutline": {
      borderWidth: 0
    }
  },
  notchedOutline: {
    borderWidth: 0
  },
  focused: {},
  formControl: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: theme.background.paper,
    borderStyle: "solid",
    borderWidth: 1,
    "&:hover": {
      borderColor: theme.palette.secondary.main
    }
  },
  formControlBlur: {
    border: theme.palette.border,
    borderRadius: 4
  },
  formControlFocus: {
    borderColor: theme.palette.secondary.dark,
    borderRadius: 4
  },
  submitButton: {
    margin: "auto",
    marginRight: 16,
    padding: 8,
    height: 38,
    width: 40
  },
  progress: {
    position: "absolute",
    top: 5,
    right: 11
  }
});
export default withStyles(styles)(withi18n(SearchField));
SearchField.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  initialValue: PropTypes.string,
  id: PropTypes.string.isRequired,
  submitButtonTitle: PropTypes.string,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
  loading: PropTypes.bool,
  autoComplete: PropTypes.string
};
SearchField.defaultProps = {
  value: undefined,
  autoFocus: false,
  loading: false,
  autoComplete: "on"
};